module.exports = __webpack_public_path__ + "static/img/1.1edc530.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/1.png
// module id = 6bkM
// module chunks = 35